import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e39beb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-image" }, null, -1))
const _hoisted_2 = { class: "new-content" }
const _hoisted_3 = { class: "new-title" }
const _hoisted_4 = { class: "new-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "new",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToCourse()))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.course.title), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.course.description), 1)
    ])
  ]))
}